import { FilesModule } from '../modules/files';
import { StartupSubPageShell } from './StartupSubPageShell';

export default function StartupFilesPage(): JSX.Element {
  return (
    <StartupSubPageShell activeSection="files">
      {({ startupId }) => <FilesModule owner={{ type: 'startup', startupId }} />}
    </StartupSubPageShell>
  );
}
